export default __webpack_public_path__ + "static/media/E02.7022b17e.mp3";